import {useMemo,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {PORTFOLIO_CATEGORY_ORDER} from '../lib/portfolioCategories';

const {FiCheck,FiChevronDown,FiChevronUp}=FiIcons;

export function getPortfolioCategory(item) {
  return String(item.category || 'Other Projects').trim();
}

export function getPortfolioFilterKey(item) {
  return getPortfolioCategory(item);
}

export default function PortfolioCategoryFilter({
  items,
  selected,
  onChange
}) {
  const [expanded,setExpanded]=useState(false);

  const categories=useMemo(()=> {
    const counts=new Map();

    items.forEach((item)=> {
      const category=getPortfolioCategory(item);
      counts.set(category,(counts.get(category) || 0) + 1);
    });

    return [...counts.entries()]
      .map(([category,count])=> ({category,count}))
      .sort((a,b)=> {
        const aIndex=PORTFOLIO_CATEGORY_ORDER.indexOf(a.category);
        const bIndex=PORTFOLIO_CATEGORY_ORDER.indexOf(b.category);
        return (aIndex < 0 ? 99 : aIndex) - (bIndex < 0 ? 99 : bIndex);
      });
  },[items]);

  const activeCategory=[...selected][0];
  const activeLabel=activeCategory || 'All projects';

  const selectCategory=(category)=> {
    onChange(category ? new Set([category]) : new Set());
    setExpanded(false);
  };

  if (!categories.length) return null;

  return (
    <section className={`portfolio-filter ${expanded ? 'is-expanded' : 'is-collapsed'}`}>
      <button
        type="button"
        className="portfolio-filter-toggle"
        onClick={()=> setExpanded((current)=> !current)}
        aria-expanded={expanded}
        aria-controls="portfolio-filter-options"
      >
        <span className="portfolio-filter-heading-copy">
          <span>Browse by category</span>
          <strong>{activeLabel}</strong>
        </span>
        <span className="portfolio-filter-toggle-icon">
          <SafeIcon icon={expanded ? FiChevronUp : FiChevronDown} />
        </span>
      </button>

      {expanded && (
        <div id="portfolio-filter-options" className="portfolio-category-options">
          <button
            type="button"
            className={!activeCategory ? 'is-active' : ''}
            onClick={()=> selectCategory('')}
          >
            <span>
              <strong>All projects</strong>
              <small>{items.length} items</small>
            </span>
            {!activeCategory && <SafeIcon icon={FiCheck} />}
          </button>

          {categories.map(({category,count})=> {
            const active=activeCategory===category;

            return (
              <button
                type="button"
                className={active ? 'is-active' : ''}
                onClick={()=> selectCategory(category)}
                key={category}
              >
                <span>
                  <strong>{category}</strong>
                  <small>{count} {count===1 ? 'item' : 'items'}</small>
                </span>
                {active && <SafeIcon icon={FiCheck} />}
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
}